function TableEditor({

  block,

  updateBlock

}) {

  // UPDATE CELL
  const updateCell = (

    rowIndex,

    colIndex,

    value

  ) => {

    const newTableData =

      block.tableData.map(

        (row, r) =>

          row.map(

            (cell, c) =>

              r === rowIndex &&
              c === colIndex

              ? value

              : cell

          )

      );

    updateBlock(

      block.id,

      {

        tableData:
          newTableData

      }

    );

  };

  return (

    <div className="table-editor">

      <table>

        <tbody>

          {

            block.tableData.map(

              (row, rowIndex) => (

                <tr key={rowIndex}>

                  {

                    row.map(

                      (

                        cell,

                        colIndex

                      ) => (

                        <td key={colIndex}>

                          <input

                            type="text"

                            value={cell}

                            onChange={(e) =>

                              updateCell(

                                rowIndex,

                                colIndex,

                                e.target.value

                              )

                            }

                          />

                        </td>

                      )

                    )

                  }

                </tr>

              )

            )

          }

        </tbody>

      </table>

    </div>

  );

}

export default TableEditor;